import { Component, OnInit } from '@angular/core';
import { Project } from '../Models/Project';
import { AppHttpService } from '../AppServices/app.httpservices';

@Component({
  selector: 'app-projects',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.css']
})
export class ProjectsComponent implements OnInit {

  ProjectList = new Array<Project>();

  constructor(private httpClient: AppHttpService) { }

  ngOnInit() {
    this.httpClient.get<Array<Project>>('api/Projects/Get', null).subscribe(data => {
      this.ProjectList = data;
  });
  }

}
